<template>
  <div>
    <v-row class="pa-5">
      <tab-sample></tab-sample>
    </v-row>
    <v-row class="pa-5">
      <v-col cols="auto">
        <agenda-meeting-card />
      </v-col>
      <v-col cols="auto">
        <agenda-card />
      </v-col>
    </v-row>
    <v-row class="pa-5">
      <expansion-sample />
    </v-row>
    <v-row class="pa-5">
      <menu-sample />
    </v-row>
    <v-row class="pa-5">
      <buttons-sample />
    </v-row>
    <v-row class="pa-5">
      <form-list-sample />
    </v-row>
    <!-- <v-row class="pa-5">
      <tree-view />
    </v-row> -->
    <v-row class="pa-5">
      <breadcrumbs-sample />
    </v-row>
    <v-row class="pa-5">
      <data-table-sample />
    </v-row>
    <v-row class="pa-5">
      <chip-sample />
    </v-row>
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
    <v-row class="pa-5">
      <v-col>
        <dialog-sample />
      </v-col>
    </v-row>
    <v-row class="pa-5">
      <v-col>
        <ExpansionSample />
      </v-col>
    </v-row>
    <v-row class="pa-5">
      <v-col>
        <MeetingCard />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MenuSample from "../wrapper-component/MenuSample.vue";
import ButtonsSample from "../wrapper-component/ButtonsSample.vue";
import ChipSample from "../wrapper-component/ChipSample.vue";
import ExpansionSample from "../wrapper-component/ExpansionSample.vue";
import MessageSheet from "../components/MessageSheet.vue";
import AgendaCard from "../wrapper-component/AgendaCard.vue";
import AgendaMeetingCard from "../wrapper-component/AgendaMeetingCard.vue";
import DataTableSample from "../wrapper-component/DataTableSample.vue";
import FormListSample from "../wrapper-component/FormListSample.vue";
import dialogSample from "../wrapper-component/dialogSample.vue";
import BreadcrumbsSample from "../wrapper-component/BreadcrumbsSample.vue";
// import TreeView from '../components/TreeView.vue';
import TabSample from "../wrapper-component/TabSample.vue";
import MeetingCard from "../wrapper-component/MeetingCard.vue";

export default {
  components: {
    ButtonsSample,
    ChipSample,
    MenuSample,
    ExpansionSample,
    MessageSheet,
    AgendaCard,
    AgendaMeetingCard,
    DataTableSample,
    FormListSample,
    dialogSample,
    BreadcrumbsSample,
    // TreeView
    TabSample,
    dialogSample,
    MeetingCard,
  },
  name: "Components",
  data() {
    return {
      displayMessage: false,
      messageType: "",
      message: "",
    };
  },
  mounted() {
    // this.showMessageSheet(
    //   "The Meeting 'Test' has been updated successfull",
    //   "error"
    // );
  },
  methods: {
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
  },
};
</script>

